import client from '@/helpers/apollo/clients/default'
import HasuraService from '@/helpers/hasura'

import _ from 'lodash'
// https://webpack.js.org/guides/dependency-management/#require-context
const requireModule = require.context(
  // Search for files in the current directory
  '.',
  // Search for files in subdirectories
  true,
  // Include any .js files
  /(.service.js)$/
)

let apis = {}

let files = _.sortBy(requireModule.keys(), el => {
  return el.split('/').length
})

files.forEach(fileName => {
  // Skip this file, as it's not a api
  if (fileName === './' || fileName === './index.js') return

  // Get the api path as an array
  const apiPath = fileName
    // Remove the "./" from the beginning
    .replace(/^\.\//, '')
    // Remove the "./" from the beginning
    .replace(/(.service.js)$/, '')
    // Remove the file extension from the end
    .replace(/\.\w+$/, '')
    // Split nested apis into an array path
    .split(/\//)
    // camelCase all api namespaces and names
    .map(_.camelCase)

  // remove if fileName is index (api in directory)
  if (apiPath[apiPath.length - 1] === 'index') {
    apiPath.pop()
  }

  const service = requireModule(fileName).default
  // Add the api to our apis object

  apis[`${apiPath.pop()}`] = new service({ client })
})

if (process.env.NODE_ENV !== 'production') {
  console.debug(apis)
}

export default apis
